import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet, View } from 'react-native';
import { theme } from '@xbto/design-system';
import { Callout } from '../../molecules';
export const NoApiKeysCallout = ({ onCtaPress, }) => {
    return (_jsx(View, { style: $.container, children: _jsx(Callout, { small: true, title: "No API keys created yet", message: "API keys that are crucial to accessing and utilizing our services. These are confidential and should be treated with the utmost care. Once generated, it is recommended that you do not display them again to prevent unauthorized access.", variant: "tertiary", ctas: [
                {
                    variant: 'secondary',
                    size: 'base',
                    label: 'Create API Key',
                    onPress: onCtaPress,
                },
            ] }) }));
};
const $ = StyleSheet.create({
    container: {
        marginVertical: theme.spacing['10'],
        maxWidth: 600,
    },
});
